/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // Initialize Slick Slider
                $('.hero__slide-wrapper').slick({
                    autoplay: true,
                    autoplaySpeed: 2500,
                    prevArrow: '<i class="fas fa-chevron-left"></i>',
                    nextArrow: '<i class="fas fa-chevron-right"></i>',
                    dots: true,
                    appendDots: $('.hero__slide-wrapper'),
                    mobileFirst: false,
                    rows: 0,
                    fade: true
                });
                // Init Inline Gallery 
                $('.gallery__inline-mobile').slick({
                    rows: 0,
                    slidesToShow: 1,
                    sliderToScroll: 1,
                    arrows: true,
                    prevArrow: '<i class="fas fa-chevron-left"></i>',
                    nextArrow: '<i class="fas fa-chevron-right"></i>', 
                    mobileFirst: true,
                    variableWidth: true
                });
                // Init Modal Slider
                $('.mod-gallery').slick({
                    rows: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: '<i class="fas fa-chevron-left"></i>',
                    nextArrow: '<i class="fas fa-chevron-right"></i>',
                    fade: true,
                    centerMode: true,
                    mobileFirst: true,
                    asNavFor: '.mod-gallery__nav'
                });
                $('.mod-gallery__nav').slick({
                    slidesToShow: 9,
                    slidesToScroll: 1,
                    asNavFor: '.mod-gallery',
                    appendArrows: $('.mod-gallery__nav'),
                    prevArrow: '<i class="fas fa-chevron-left"></i>',
                    nextArrow: '<i class="fas fa-chevron-right"></i>',
                    dots: false,
                    centerMode: true,
                    centerPadding: '7.5px',
                    focusOnSelect: true
                });
                // hook into Bootstrap shown event and manually trigger 'resize' event so that Slick recalculates the widths
                $('#mod-gallery').on('shown.bs.modal', function () {
                    $('.mod-gallery').resize();
                    $('.mod-gallery__nav').resize();
                });
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'gallery': {
            init: function () {
                // JavaScript to be fired on the gallery page

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
    var $gallery = $('.grid').masonry({
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
    // layout Masonry after each image loads
    $gallery.imagesLoaded().progress(function () {
        $gallery.masonry('layout');
    });
    // hook into Bootstrap shown event and manually trigger 'resize' event so that Slick recalculates the widths
    $('#mod-gallery').on('shown.bs.modal', function () {
        $('.mod-gallery').resize();
        $('.mod-gallery__nav').resize();
    });
    // Try to resize images for phone on inline slider
    var viewportWidth = $(window).width();
    if (viewportWidth < 480) {
        var imgWidth = $(window).width();
        var imgHeight = (imgWidth * .584);
        $(".gallery__inline-mobile .gallery__inline-large-image img").width(imgWidth).height(imgHeight);
        }
    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('[href="#mod-gallery"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };
                    });
                }
                $('.navbar-collapse').removeClass('in');
            }
        });


})(jQuery); // Fully reference jQuery after this point.